import { Routes } from '@angular/router';

import { platformAdminGuard } from './core/guards/platform-admin.guard';
import { ShellComponent } from './core/layout/shell/shell.component';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'login/oauth2-callback',
    loadComponent: () =>
      import('./features/login/oauth2-callback.component').then(
        (m) => m.OAuth2CallbackComponent,
      ),
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [platformAdminGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'admins' },
      {
        path: 'admins',
        loadComponent: () =>
          import('./features/platform-admins/platform-admins-list.component').then(
            (m) => m.PlatformAdminsListComponent,
          ),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./features/users/users-list.component').then((m) => m.UsersListComponent),
      },
      {
        path: 'events',
        loadComponent: () =>
          import('./features/events/events-list.component').then((m) => m.EventsListComponent),
      },
      {
        path: 'events/new',
        loadComponent: () =>
          import('./features/events/curated-event-form.component').then(
            (m) => m.CuratedEventFormComponent,
          ),
      },
      {
        path: 'events/:id/edit',
        loadComponent: () =>
          import('./features/events/curated-event-form.component').then(
            (m) => m.CuratedEventFormComponent,
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'admins' },
];
